export default __webpack_public_path__ + "files/media/md-nysf.c1d8f91e.jpg";